<div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
  <div class="mt-8 sm:mt-16 bg-brand-50 rounded-lg shadow-lg overflow-hidden">
    <div class="p-6 sm:p-10">
      <div class="text-center">
        <h2 class="text-lg sm:text-lg font-bold text-foreground mb-6">Welcome to {{ brand.productName }}!</h2>
      </div>
      <div class="space-y-4 text-center text-gray-700">
        <p class="text-base sm:text-lg">
          We're thrilled to have you as a member of our community. Get ready to unlock a wealth of valuable information
          and insightful analyses and register to our regular events with interesting companies.
        </p>
        <p class="text-base sm:text-lg">Best regards,</p>
        <p class="text-base sm:text-lg font-semibold">The {{ brand.companyName }} Team</p>
      </div>
      <div class="mt-8 text-center">
        <a class="inline-block" [routerLink]="['/user/dashboard']">
          <button
            class="bg-brand-500 hover:bg-brand-700 text-white px-6 py-3 text-base sm:text-lg font-medium transition duration-150 ease-in-out shadow-md hover:shadow-lg focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2">
            To your Dashboard
          </button>
        </a>
      </div>
    </div>
  </div>
</div>
